import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconArrowDown: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg height={$size} viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.79289 16.7071C7.18342 17.0976 7.81658 17.0976 8.20711 16.7071L14.5711 10.3431C14.9616 9.95262 14.9616 9.31946 14.5711 8.92893C14.1805 8.53841 13.5474 8.53841 13.1569 8.92893L7.5 14.5858L1.84315 8.92893C1.45262 8.53841 0.819456 8.53841 0.428932 8.92893C0.0384074 9.31946 0.0384074 9.95262 0.428932 10.3431L6.79289 16.7071ZM6.5 -4.37114e-08L6.5 16L8.5 16L8.5 4.37114e-08L6.5 -4.37114e-08Z"
        fill="#BEC2C4"
      />
    </svg>
  </IconStyled>
);

IconArrowDown.defaultProps = iconDefaultProps;
IconArrowDown.displayName = 'IconArrowDown';

export default IconArrowDown;
